import clsx from 'clsx';
import { startOnlineBookingWaitlistThunk } from 'actions/onlineBooking/actions/OnlineBookingWaitlistActions';
import { Button } from 'components/UI/Button/Button';
import { useMarketplace } from 'hooks/useMarketplace';
import React from 'react';
import { useSelector } from 'react-redux';
import {
    filterOnlineBookingWaitlistItems,
    getOnlineBookingItems
} from 'reducers/onlineBooking/OnlineBookingSelectors';
import { dispatch } from 'store';
import { MarketplaceServiceCategory } from 'types/Marketplace';
import classes from './JoinWaitlistCta.module.scss';

interface JoinWaitlistCtaProps {
    category: MarketplaceServiceCategory;
    className?: string;
}

export const JoinWaitlistCta: React.FC<JoinWaitlistCtaProps> = ({ category, className }) => {
    const marketplace = useMarketplace();
    const bookingItems = useSelector(getOnlineBookingItems);

    const hasWaitlistServices = React.useMemo(
        () => filterOnlineBookingWaitlistItems(bookingItems, category).some(item => item.service),
        [bookingItems, category]
    );

    if (!marketplace.settings.waitlistEnabled || !hasWaitlistServices) {
        return null;
    }

    return (
        <div className={clsx(classes.root, className)}>
            <h2 className={clsx('h2', classes.title)}>Join Waitlist</h2>

            <p className={classes.description}>
                No availability for your preferred time? We&apos;ll let you know if a spot opens up.
            </p>

            <Button
                variant="green"
                className={classes.button}
                onClick={() => dispatch(startOnlineBookingWaitlistThunk(category))}
            >
                Join Waitlist
            </Button>
        </div>
    );
};
